import { invalidateByScope } from '#app/helpers/invalidateByScope';
import { InvalidationScope } from '#app/constants/invalidationScopes';
import CacheHelper from '#app/helpers/Cache/CacheHelper';

/**
 * Полный refresh пользовательских данных без window reload:
 * 1) очищает весь кеш TanStack Query;
 * 2) запускает широкую инвалидацию + redux обновления (CLIENT_SWITCH);
 * 3) догружает связанные данные интеграций/баланса.
 */
export async function refreshAllUserData({ queryClient, dispatch, client }) {
  if (!queryClient || !dispatch) return;

  queryClient.clear();
  CacheHelper.startAgain();

  await invalidateByScope(InvalidationScope.CLIENT_SWITCH, {
    queryClient,
    dispatch,
    params: {
      clientId: client?.id,
      client,
    },
  });
}

export default refreshAllUserData;
